module.exports = __webpack_public_path__ + "static/media/pops-strawberry-lemon-lime.304d3e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/nutrition-facts/pops-strawberry-lemon-lime.png
// module id = 175
// module chunks = 0